import SingleAssignmentView from "@features/assignments/SingleAssignment/view";

const SingleAssignment = () => {
  return <SingleAssignmentView />;
};

export default SingleAssignment;
